import { render, staticRenderFns } from "./bodyBtn.vue?vue&type=template&id=5e51be7e&scoped=true"
import script from "./bodyBtn.vue?vue&type=script&lang=js"
export * from "./bodyBtn.vue?vue&type=script&lang=js"
import style0 from "./bodyBtn.vue?vue&type=style&index=0&id=5e51be7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e51be7e",
  null
  
)

export default component.exports